import { getFilterDetailsFun } from '../../../api/infoAPI';
import errorHandle from '../../../utils/errorHandle';

export const fetchFiltersData = async (type, setFilterData) => {
    try {
        const filters = await getFilterDetailsFun(type);
        setFilterData(filters.data);
    } catch (error) {
        errorHandle(error);
    }
};

export const fetchDataBaseOnLocation = async (type, setLocationData) => {
    try {
        const filters = await getFilterDetailsFun(type);
        const cityData = filters?.data
            ?.filter((item) => item.heading === 'Base Cities')
            .map((cityItem) => cityItem.dropdown);
        setLocationData(cityData[0]);
    } catch (error) {
        errorHandle(error);
    }
};
